<template lang="pug">
div.fd-criterion(:class="{ 'ui-disabled': criterion.isDisabled }")
    label.fd-criterion-label(:title="criterion.label") {{ criterion.label }}
    div.fd-criterion-settings
        div.fd-criterion-setting.long-value(
            v-if="showFrequency"
            :title="getTitle('period')") {{ period }}
        div.fd-criterion-setting.long-value(
            v-if="showFrequency"
            :title="getTitle('frequency')") {{ frequency }}
        div.fd-criterion-setting(
            :title="getTitle('recency')") {{ recency }}
        div.fd-criterion-setting(
            v-if="showQuantile"
            :title="getTitle('quantile')") {{ quantile }}
        div.fd-criterion-setting(
            v-if="showSurfIntensity"
            :title="getTitle('surfIntensity')") {{ surfIntensity }}
</template>

<script>
import { startCase } from 'lodash'

export default {
    props: {
        criterion: {
            type: Object,
            required: true
        }
    },

    computed: {
        showFrequency() {
            return this.$store.state.data.settings.general.frequency
        },
    
        showSurfIntensity() {
            return this.$store.state.data.settings.general.surfintensity
        },
    
        showQuantile() {
            return this.$store.state.data.settings.general.quantile
        },
    
        period() {
            return this.criterion.frequencySelectedInString ?? '-'
        },
    
    
        frequency() {
            return this.criterion.frequencyRangeInString ?? '-'
        },
    
        recency() {
            return this.criterion.recency.value ?? '-'
        },
    
        quantile() {
            return this.criterion.quantile?.value ?? '-'
        },
    
        surfIntensity() {
            return this.criterion.surfIntensity?.value ?? '-'
        }
    },

    methods: {
        getTitle(source) {
            if (this[source] !== '-') {
                if (source === 'recency') return this.recency === 1 ? 'Recency: 1 day' : `${startCase(source)}: ${this[source]} days`
                return `${startCase(source)}: ${this[source]}`
            }
        }
    }
}
</script>
